// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "eabe11fc" : chunkId) + "." + {"167":"52f5d79ac0d60e77","937":"8227f13573cb1f30"}[chunkId] + ".js";
};